export default __webpack_public_path__ + "static/media/loader.24787574.gif";